import { connect } from 'react-redux';
import CollectiveApplication from './collective-application';
import { signupMultiple } from '../reducers/auth.reducers';

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
  signup: dto => dispatch(signupMultiple(dto)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CollectiveApplication);



// WEBPACK FOOTER //
// ./src/app/collective-application/collective-application.container.js